import React from "react";
import { useNavigate } from "react-router";
import { BASE_URL } from "../../../../static/constants";
import getToken from "../../../../utils/getToken";

// Material Imports
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import ErrorIcon from "@mui/icons-material/Error";

// Import CSS
import "./index.css";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { showErrorToast, showSuccessToast } from "utils/toast";

export default function ChangePasswordModal(props) {
  const {
    passwordModalOpen,
    closePasswordModal,
    fromLoginPage,
    loginUser,
    authToken,
    userEmail,
  } = props;
  const [oldPassword, setOldPassword] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  const [passwordLengthValid, setPasswordLengthValid] = React.useState(false);
  const [passwordValid, setPasswordValid] = React.useState(false);
  const [oldPasswordVisible, setOldPasswordVisible] = React.useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = React.useState(false);

  const navigate = useNavigate();

  const onClose = () => {
    closePasswordModal();
    setNewPassword("");
    setOldPassword("");
    setPasswordLengthValid(false);
    setPasswordValid(false);
  };

  const onOldPasswordChange = (e) => {
    setOldPassword(e.target.value);
  };

  const toggleOldPasswordVisible = () => {
    setOldPasswordVisible(!oldPasswordVisible);
  };

  const toggleNewPasswordVisible = () => {
    setNewPasswordVisible(!newPasswordVisible);
  };

  const onNewPasswordChange = (e) => {
    const val = e.target.value;
    setNewPassword(val);
    if (val.length < 12) {
      setPasswordLengthValid(false);
    } else {
      setPasswordLengthValid(true);
    }

    var pattern = new RegExp(
      /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*].*$/
    );
    const isValid = pattern.test(val);

    if (isValid) {
      setPasswordValid(true);
    } else {
      setPasswordValid(false);
    }
  };

  const savePassword = () => {
    let token = getToken();
    if (fromLoginPage) {
      token = authToken;
    }

    fetch(`${BASE_URL}/user/changePassword`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        prevPassword: oldPassword,
        newPassword: newPassword,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.error) {
          throw Error(response.message);
        }
        if (fromLoginPage) {
          loginUser(userEmail, newPassword);
        }
        showSuccessToast(response.message);
        onClose();
      })
      .catch((error) => {
        const errorStr = error.toString();
        if (errorStr === "Error: jwt malformed") {
          navigate("/login");
        }
        if (errorStr === "Error: jwt expired") {
          navigate("/login");
        }
        if (errorStr === "Error: Unauthorized") {
          navigate("/prohibited");
        }

        showErrorToast(errorStr);
        onClose();
      });
  };

  return (
    <div>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={passwordModalOpen}
        onClose={onClose}
      >
        <div className="user-modal__container">
          <Paper>
            <div
              className="user-modal__wrapper"
              style={{ padding: "40px 40px", textAlign: "left" }}
            >
              <Tooltip title="Close" placement="bottom">
                <div onClick={onClose} className="user-modal__close">
                  <CloseIcon />
                </div>
              </Tooltip>
              {fromLoginPage && (
                <div style={{ color: "red", display: "flex" }}>
                  <ErrorIcon style={{ marginRight: 10 }} /> Your password has
                  expired.
                  <br />
                  Please update your password to continue.
                </div>
              )}
              {!fromLoginPage && <h2>Change Password</h2>}
              <div>
                <div style={{ marginBottom: "20px", marginTop: "20px" }}>
                  <div style={{ position: "relative" }}>
                    {!oldPasswordVisible && (
                      <VisibilityIcon
                        onClick={toggleOldPasswordVisible}
                        style={{
                          position: "absolute",
                          top: 13,
                          right: 5,
                          zIndex: "999",
                          cursor: "pointer",
                        }}
                      />
                    )}
                    {oldPasswordVisible && (
                      <VisibilityOffIcon
                        onClick={toggleOldPasswordVisible}
                        style={{
                          position: "absolute",
                          top: 13,
                          right: 5,
                          zIndex: "999",
                          cursor: "pointer",
                        }}
                      />
                    )}
                    <TextField
                      id="old_password"
                      label="Old Password"
                      className=""
                      type={!oldPasswordVisible ? "password" : "text"}
                      margin="none"
                      onChange={onOldPasswordChange}
                      fullWidth
                      value={oldPassword}
                    />
                  </div>
                  <div style={{ marginTop: 20, position: "relative" }}>
                    {!newPasswordVisible && (
                      <VisibilityIcon
                        onClick={toggleNewPasswordVisible}
                        style={{
                          position: "absolute",
                          top: 13,
                          right: 5,
                          zIndex: "999",
                          cursor: "pointer",
                        }}
                      />
                    )}
                    {newPasswordVisible && (
                      <VisibilityOffIcon
                        onClick={toggleNewPasswordVisible}
                        style={{
                          position: "absolute",
                          top: 13,
                          right: 5,
                          zIndex: "999",
                          cursor: "pointer",
                        }}
                      />
                    )}
                    <TextField
                      id="new_password"
                      label="New Password"
                      type={!newPasswordVisible ? "password" : "text"}
                      className=""
                      margin="none"
                      onChange={onNewPasswordChange}
                      error={
                        (!passwordLengthValid || !passwordValid) &&
                        newPassword.length > 0
                      }
                      fullWidth
                      value={newPassword}
                    />
                    {(!passwordLengthValid || !passwordValid) &&
                      newPassword.length > 0 && (
                        <div
                          style={{
                            color: "red",
                            textAlign: "right",
                            margin: "20px 0",
                          }}
                        >
                          Error: Password must contain at least 12 characters
                          including one number and one special character.
                        </div>
                      )}
                  </div>
                </div>
                <div className="view-pdf__button-container">
                  <Button
                    onClick={onClose}
                    className="view-pdf__button"
                    variant="outlined"
                    color="secondary"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={savePassword}
                    className="view-pdf__button"
                    variant="contained"
                    color="secondary"
                    disabled={
                      !passwordLengthValid ||
                      !passwordValid ||
                      !oldPassword.length > 0
                    }
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </Paper>
        </div>
      </Modal>
    </div>
  );
}
